// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { Team_abstract } from './../abstract/SagaSchema/Team_abstract';
export class Team extends Team_abstract {}
